import React from 'react';

interface HorizontalLineProps {
  className?: string;
  ariaHidden?: boolean;
}
const HorizontalLine: React.FC<HorizontalLineProps> = ({ className, ariaHidden }) => {
  return <hr className={className} aria-hidden={ariaHidden} />;
};

export default HorizontalLine;
